import React from 'react';
import HeadingPlaceholder from '../shared/HeadingPlaceholder';
import BackButton from '../shared/BackButton';
import MenuCourses from './MenuCourses';
import TextAreaView from '../shared/TextAreaView';
import SVGCopy from '../../svg/Copy';
import SVGTrash from '../../svg/Trash';
import SVGMail from '../../svg/Mail';

class MenuCompanyLayout extends React.Component {
  state = {
    isSubmitting: false
  };

  render() {
    const { props } = this;
    const { isEdit, menu, openModal } = props;

    return (
      <div className="cms menu">
        <div className="cms__head cms__head--padding">
          <div className="cms__content">
            <BackButton defaultUrl="/admin/menus/company" />
            <div className="cms__bar">
              <div className="cms__bar-inputs">
                <HeadingPlaceholder
                  name="name"
                  placeholder="Company Menu Name"
                  label="Company Menu"
                  isEdit={isEdit}
                  onChange={e =>
                    this.props.updateMenu({ [e.target.name]: e.target.value })
                  }
                  value={menu.name}
                  required
                />
              </div>
              {this.renderCTAs()}
            </div>
          </div>
        </div>

        <div className="cms__body">
          <MenuCourses {...props} />

          <div className="cms__content cms__content--pad-top">
            <div className="row">
              <div className="row__item row__item--half">
                <TextAreaView
                  title="Private Notes"
                  isEdit={true}
                  value={menu.notes}
                  openEdit={() => openModal('notes')}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderCTAs() {
    const {
      isEdit,
      toggleEdit,
      menu,
      openModal,
      submitSave,
      saveInProgress
    } = this.props;
    const isExisting = 'id' in menu && menu.id > 0;

    let saveClasses = 'btn btn--solid-blue';
    if (saveInProgress || !isEdit) {
      saveClasses += ' disabled';
    }

    return (
      <div className="cms__bar-ctas">
        {isExisting ? (
          <div
            className="btn-icon btn-icon--trash"
            onClick={() => openModal('delete')}
          >
            <SVGTrash />
          </div>
        ) : (
          ''
        )}
        {isExisting ? (
          <div
            className="btn-icon btn-icon--copy"
            onClick={() => openModal('duplicate')}
          >
            <SVGCopy />
          </div>
        ) : (
          ''
        )}
        {isExisting ? (
          <div
            className="btn-icon btn-icon--mail"
            onClick={() => openModal('send-occasion')}
          >
            <SVGMail />
          </div>
        ) : (
          ''
        )}
        <div className="btn btn--hollow-blue" onClick={toggleEdit}>
          {isEdit ? 'Preview' : 'Edit'}
        </div>
        <div className={saveClasses} onClick={submitSave}>
          {isExisting ? 'Update' : 'Add'}
        </div>
      </div>
    );
  }
}

export default MenuCompanyLayout;



// WEBPACK FOOTER //
// ./src/components/menu/MenuCompanyLayout.js